import styled from 'styled-components';
import { Popup as SemanticPopup } from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #E5E5E5;
  display: flex;
  height: min-content;
  justify-content: space-between;
  padding: 10px;
  width: 100%;

  ${({ hasMargin }) => hasMargin && `
    margin: 10px 0;

    :first-child {
      margin-top: 0;
    }

    :last-child {
      margin-bottom: 0;
    }
  `}
`;

export const Text = styled(TextLayoutComponent)`
  word-break: break-word;

  ${({ tooltip }) => tooltip && `
    font-size: 12px;
  `}
`;

export const Popup = styled(SemanticPopup)`
  &.ui.popup {
    background: ${({ theme }) => theme.color.tooltipDescription};
    border: solid 1px ${({ theme }) => theme.color.tooltipDescription};

    :before {
      background: ${({ theme }) => theme.color.tooltipDescription};
      box-shadow: 1px 1px 0 0 ${({ theme }) => theme.color.tooltipDescription};
    }
  }
`;

export const TooltipDescription = styled.div`
  display: flex;
  background: ${({ theme }) => theme.color.tooltipDescription};
  padding: 2px;
  min-width: 20px;
  max-width: 20px;
  height: max-content;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
`;
